module.exports = {"430181001":"淮川街道","430181002":"集里街道","430181003":"荷花街道","430181004":"关口街道","430181102":"社港镇","430181104":"官渡镇","430181105":"张坊镇","430181106":"达浒镇","430181107":"沿溪镇","430181108":"古港镇","430181109":"永和镇","430181110":"大瑶镇","430181111":"金刚镇","430181112":"文家市镇","430181114":"枨冲镇","430181115":"镇头镇","430181116":"普迹镇","430181117":"永安镇","430181118":"北盛镇","430181120":"龙伏镇","430181121":"澄潭江镇","430181122":"中和镇","430181123":"柏加镇","430181124":"洞阳镇","430181125":"大围山镇","430181126":"沙市镇","430181127":"淳口镇","430181128":"高坪镇","430181130":"官桥镇","430181131":"葛家镇","430181201":"小河乡","430181211":"蕉溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430181.json
// module id = 1660
// module chunks = 0